import React, { useEffect, useState } from "react";

import "./styles.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setEvaluation } from "../../actions/evaluationActions";

const Countdown = props => {
  const [trigger, setTrigger] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [maxTime, setMaxTime] = useState(0);
  const [time, setTime] = useState(props.time);

  useEffect(() => {
    const intervalId = setInterval(() => setTrigger(trigger => !trigger), 1000);

    return () => clearInterval(intervalId); // This is important
  }, []);

  useEffect(() => {
    // setMaxTime(props.time * 60);
    setIsActive(true);
  }, [props.time]);

  useEffect(() => {
    if (!props.disable) {
      if (time > 0) {
        setTime(time - 1);
        setTime(time - 1);
      } else if (isActive) {
        setIsActive(false);
        props.handleFinishTime();
      }

      const newTimeInMinutes = Math.floor(time / 60);
      props.handleCurrentTime(time);
      props.setEvaluation({
        time
      });
    }
  }, [trigger]);

  function displayTime(time) {
    // time = 60 * 60 = 3600segs
    const hour = Math.floor(time / 3600);
    // hora = 1
    const minutes = Math.floor((time - hour * 3600) / 60);

    // 3600 - 1 * 3600 / 60 -> 0
    const seconds = time % 60;

    let hourString = hour.toString();
    let minutesString = minutes.toString();
    let secondsString = seconds.toString();

    hourString = hourString.length === 1 ? `0${hourString}` : hourString;
    minutesString =
      minutesString.length === 1 ? `0${minutesString}` : minutesString;
    secondsString =
      secondsString.length === 1 ? `0${secondsString}` : secondsString;

    return `${hourString}:${minutesString}:${secondsString}`;
  }

  return (
    <div className={time < 600 ? "clock-border bg-danger" : "clock-border"}>
      <div className="clock-frame">
        <span className={time < 600 ? "text-danger" : "text-primary"}>
          {displayTime(time)}
        </span>
      </div>
    </div>
  );
};
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  evaluation: state.evaluation
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logout, setEvaluation }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Countdown);
